<template>
  <div class="echarts-module-wrapper">
    <ChartBox :title="title" :more="showMore ? '更多' : ''">
      <div class="feedback-compact-container">
        <div class="main-content">
          <div class="stats-column">
            <div class="stats-card today-bg">
              <div class="label">今日投票</div>
              <div class="value-wrap">
                <span class="number num-today">{{ todayCount }}</span>
                <span class="unit">票</span>
              </div>
            </div>
            <div class="stats-card total-bg">
              <div class="label">累计总数</div>
              <div class="value-wrap">
                <span class="number num-total">{{ totalCount }}</span>
                <span class="unit">票</span>
              </div>
            </div>
          </div>

          <div class="qr-column">
            <div class="qr-box">
              <img v-if="qrCodeUrl" :src="qrCodeUrl" class="qr-img" alt="二维码" />
              <div v-else class="qr-none">
                <i class="el-icon-loading"></i>
              </div>
              <!-- <div class="scan-line" v-if="qrCodeUrl"></div> -->
            </div>
            <div class="qr-label">扫码参与投票</div>
          </div>
        </div>

        <!-- <div class="bottom-tips">
          <i class="el-icon-info"></i>
          <span>扫码可实时查看投票统计结果</span>
        </div> -->
      </div>
    </ChartBox>
  </div>
</template>

<script>
import ChartBox from "./chartBox.vue";
import { getVoteResult } from "../api/api";
import { myMixin } from "../common/common.js";

export default {
  name: "EChartsModule",
  mixins: [myMixin],
  components: {
    ChartBox
  },
  props: {
    chartTitle: {
      type: String,
      default: "满意度反馈"
    },
    showMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      todayCount: 0,
      totalCount: 0,
      qrCodeUrl: "",
      refreshTimer: null,
      title:''
    };
  },
  mounted() {
    // 初始获取数据
    this.fetchVoteData();
    
    // 设置定时器，每 10 分钟自动更新一次数据
    this.refreshTimer = setInterval(() => {
      this.fetchVoteData();
    }, 10 * 60 * 1000);
  },
  beforeDestroy() {
    // 销毁组件前清除定时器，防止内存泄漏
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    async fetchVoteData() {
      try {
        // 使用混入中的 vote_id 或自行定义的逻辑
        const res = await getVoteResult({ vote_id: this.vote_id });
        
        if (res.data && res.data.code === 1 && res.data.data) {
          const serverData = res.data.data;

          // 1. 更新总人数 (累计)
          this.totalCount = serverData.voteInfo?.vote_amount || 0;
          
          // 2. 更新今日人数 (如果后端没有直接给今日字段，可从 amout 总计中获取，这里假设后端有逻辑)
          // 注意：请根据你接口实际返回的今日字段进行调整
          this.todayCount = serverData.voteInfo?.todayVotes || 0;

          // 3. 更新二维码地址
          this.qrCodeUrl = serverData.voteInfo?.qrcode || "";
          this.title = serverData.voteInfo?.title
          
          console.log("投票数据更新成功:", this.qrCodeUrl);
        }
      } catch (error) {
        console.error("获取投票结果失败:", error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.echarts-module-wrapper {
  width: 100%;
  height: 100%;
  
  ::v-deep .chart-box-content {
    height: calc(100% - 40px);
  }
}

.feedback-compact-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px 12px;
  box-sizing: border-box;
  color: #fff;
  overflow: hidden;
  justify-content: center;
}

.main-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  flex: 1;
  min-height: 0;
}

.stats-column {
  // flex: 1;
  display: flex;
  flex-direction: column;
  gap: 25px;
  
  .stats-card {
    padding: 10px 15px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05);
    //border-left: 4px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    &.today-bg { 
    //   border-left-color: #50e3c2; 
      background: rgba(80, 227, 194, 0.15); 
    }
    &.total-bg { 
    //   border-left-color: #4a90e2; 
      background: rgba(74, 144, 226, 0.15); 
    }

    .label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.6);
      margin-bottom: 2px;
      font-weight: bold;
    }
    .value-wrap {
      display: flex;
      align-items: baseline;
      .number {
        font-size: 24px;
        font-weight: bold;
        font-family: "DIN", sans-serif;
      }
      .num-today { color: #50e3c2; }
      .num-total { color: #4a90e2; }
      .unit { font-size: 11px; margin-left: 4px; opacity: 0.5; }
    }
  }
}

.qr-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .qr-box {
    position: relative;
    width: 170px; 
    height: 170px;
    background: #fff;
    padding: 2px;
    border-radius: 4px;
    margin-right: 10px;
    overflow: hidden;
    margin-top: 10px;

    .qr-img { width: 100%; height: 100%; display: block; }
    .qr-none {
      width: 100%; height: 100%; display: flex; align-items: center; 
      justify-content: center; color: #ccc; font-size: 24px;
    }
    
    .scan-line {
      position: absolute;
      top: 0; left: 0; width: 100%; height: 2px;
      background: #4a90e2;
      box-shadow: 0 0 8px #4a90e2;
    //   animation: scanMove 2.5s linear infinite;
    }
  }
  .qr-label {
    font-size: 13px;
    margin-top: 8px;
    color: #fff;
    font-weight: 500;
  }
}

.bottom-tips {
  height: 28px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #f5a623;
  opacity: 0.9;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 8px;
  i { margin-right: 6px; }
}

@keyframes scanMove {
  0% { top: 0; }
  100% { top: 100%; }
}
</style>